import PowerIcon from "@mui/icons-material/Power";
import PowerOffIcon from "@mui/icons-material/PowerOff";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, IconButton, Tooltip, keyframes } from "@mui/material";
import {
  DeveloperSettingsContext,
  HHNTheme,
  useSocketStatus,
} from "hhn-commons";
import { useContext } from "react";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const ConnectionStatusButton = () => {
  const { developerModeEnabled } = useContext(DeveloperSettingsContext);
  const { isConnected, isConnecting, disconnectAll, reconnect } =
    useSocketStatus();

  if (!developerModeEnabled) return null;

  const handleClick = async () => {
    if (isConnected) {
      await disconnectAll();
    } else if (!isConnecting) {
      await reconnect();
    }
  };

  const getStatusColor = () => {
    if (isConnected) return HHNTheme.connection.connected;
    if (isConnecting) return HHNTheme.connection.connecting;
    return HHNTheme.connection.disconnected;
  };

  const getIcon = () => {
    if (isConnected) {
      return <PowerIcon htmlColor="white" />;
    }
    if (isConnecting) {
      return (
        <SyncIcon
          htmlColor="white"
          sx={{ animation: `${spin} 1s linear infinite` }}
        />
      );
    }
    return <PowerOffIcon htmlColor="white" />;
  };

  const tooltipText = isConnected
    ? "All Connected - Click to disconnect all"
    : isConnecting
      ? "Connecting..."
      : "Disconnected - Click to reconnect all";

  return (
    <Tooltip title={tooltipText} placement="right-end">
      <IconButton size="large" color="inherit" onClick={handleClick}>
        <Box sx={{ position: "relative", display: "flex" }}>
          {getIcon()}
          <Box
            sx={{
              position: "absolute",
              bottom: -2,
              right: -2,
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: getStatusColor(),
              border: "1px solid white",
            }}
          />
        </Box>
      </IconButton>
    </Tooltip>
  );
};
